const instructions = {
  access: 'Permitir el acceso a la cámara',
  network: 'Estar conectado a la red',
  point: 'Apunte la cámara a un GEEQUIP QRCode',
};

export default instructions;
